import Card from "components/Card/Card";
import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  ControlLabel,
  FormGroup,
  Grid,
  Button,
  FormControl,
  Table,
  OverlayTrigger,
  Pagination,
  Modal,
} from "react-bootstrap";
import Collapsible from "react-collapsible";
import Datetime from "react-datetime";
import LoadingSpinner from "views/Components/loadingSpinner";
import NotificationSystem from "react-notification-system";
import ScreenLoader from "views/Components/screenLoader";
import moment from "moment";
import Select from "react-select";
import {
  AddUtilsData,
  getAllUtilData,
  utilImageUpload,
  getAllCustomUtilData,
  getAllPackageDetails,
  searchPackages,
} from "../../../api/utils/ProductUtility";

const ProductUtility = () => {
  const _notificationSystem = React.createRef();
  const [utilData, setUtilData] = useState([]);
  const [customUtilData, setCustomUtilData] = useState([]);
  const [isPDFLoading, setIsPDFLoading] = useState(false);
  const [isGRNLoading, setIsGRNLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [packageId, setPackageId] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [customCurrentPage, setCustomCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState();
  const [cutomtotalPage, setCustomTotalPage] = useState();
  const [loading, setloading] = useState(false);
  const [noRecordFound, setnoRecordFound] = useState(false);
  const [utilsResponse, setUtilsResponse] = useState();
  const [isImgaeUploadModel, setIsImgaeUploadModel] = useState(false);
  const [profile, setProfile] = useState("");
  const [selectStartDate, setSelectStartDate] = useState("");
  const [selectEndDate, setSelectEndDate] = useState("");
  const [uploadResponse, setUploadResponse] = useState(null);
  const [endDateError, setEndDateError] = useState(null);
  const [startDateError, setStartDateError] = useState(null);
  const [selectEndDateError, setSelectEndDateError] = useState(null);
  const [selectStartDateError, setSelectStartDateError] = useState(null);
  const [fileError, setFileError] = useState(null);
  const [optionsPackage, setOptionsPackage] = useState([]);
  const [selectedOptionPackage, setSelectedOptionPackage] = useState(null);
  const [packageNameError, setPackageNameError] = useState(null);
  const [searchByPackageWise, setSearchByPackageWise] = useState([]);
  const [getBySearch, setGetBySearch] = useState("");

  const GetAllPackages = async () => {
    try {
      const data = await getAllPackageDetails();
      const selectPackgeOption = data.map((pkg) => ({
        value: pkg.id,
        label: pkg.title,
      }));
      setOptionsPackage(selectPackgeOption);
    } catch (error) {
      console.error("Error fetching packages:", error);
    }
  };
  const handleChangePackage = (selected) => {
    setSelectedOptionPackage(selected);
    if (selected) {
      setPackageNameError(null);
    }
  };

  const handleDeliveryStartDateChange = (value) => {
    const Start_date = moment(value).format("YYYY-MM-DD");
    setStartDate(Start_date);
    if (Start_date) {
      setStartDateError(null);
    }
  };

  const handleDeliveryEndDateChange = (value) => {
    const end_date = moment(value).format("YYYY-MM-DD");
    setEndDate(end_date);
    if (startDate && new Date(end_date) >= new Date(startDate)) {
      setEndDateError(null);
    }
  };

  const handleSelectEndDateChange = (value) => {
    const getEndDate = moment(value).format("YYYY-MM-DD");
    setSelectEndDate(getEndDate);
    if (selectStartDate && new Date(getEndDate) >= new Date(selectStartDate)) {
      setSelectEndDateError(null);
    }
  };

  const handleSelectStartDateChange = (value) => {
    const getStartDate = moment(value).format("YYYY-MM-DD");
    setSelectStartDate(getStartDate);
    if (getStartDate) {
      setSelectStartDateError(null);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setProfile(e.target.files[0]);
      setFileError(null);
    }
  };

  const upload = () => {
    document.getElementById("selectImage").click();
  };
  const goToPage = (page) => {
    setCurrentPage(page);
  };
  const handleSearch = (event) => {
    const value = event.target.value;
    setGetBySearch(value);
    if (value.trim() === "") {
      getAllUtilDatas(1);
    } else {
      getAllPackagesData(value, 1);
    }
  };

  const getAllPackagesData = async (name, page = 1) => {
    try {
      const res = await searchPackages(name, page);
      setUtilData(res.data);
      setCurrentPage(1);
      setTotalPage(1);
    } catch (error) {
      console.error("Error fetching packages:", error);
    }
  };

  useEffect(() => {
    GetAllPackages();
    if (!getBySearch || getBySearch.trim() === "") {
      getAllUtilDatas(currentPage);
      UtillApiCallForCustomeUtil();
      const interval = setInterval(() => {
        getAllUtilDatas(currentPage);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [currentPage, getBySearch]);

  let active = currentPage;
  let items = [];
  for (let number = 1; number <= totalPage; number++) {
    items.push(
      <Pagination.Item
        key={number}
        onClick={() => {
          setGetBySearch("");
          getAllUtilDatas(number);
        }}
        active={number === active}
      >
        {number}
      </Pagination.Item>
    );
  }

  const getAllUtilDatas = async (page = 1) => {
    if (getBySearch && getBySearch.trim() !== "") return;

    const res = await getAllUtilData(page);
    setUtilData(res.data);
    setCurrentPage(res.pagination.page);
    setTotalPage(res.pagination.total_pages);
    setloading(false);
  };

  const UtillApiCallForCustomeUtil = () => {
    getAllCustomUtilData()
      .then((res) => {
        setCustomUtilData(res.data || []);
      })
      .catch((err) => {
        console.error("Error fetching custom utility data:", err);
      });
  };

  const handleutilReset = () => {
    setStartDate("");
    setEndDate("");
    setPackageId("");
    setStartDateError(null);
    setEndDateError(null);
    setSelectedOptionPackage(null);
    setPackageNameError(null);
    setGetBySearch("");
  };

  const handleDownloads = () => {
    const link = document.createElement("a");
    link.href =
      "https://welltech-flash-dev.s3.ap-south-1.amazonaws.com/util/sample+lead+list.csv";
    link.download = "sample_dummy.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleOnSubmit = async () => {
    let error = false;
    const notification = _notificationSystem.current;
    const full_report = "false";

    if (startDate && endDate && new Date(endDate) < new Date(startDate)) {
      error = true;
      setEndDateError("Invalid date range.");
      return;
    }

    if (!startDate) {
      error = true;
      setStartDateError("Start Date is required.");
      return;
    }

    if (!endDate) {
      error = true;
      setEndDateError("End Date is required.");
      return;
    }
    if (!selectedOptionPackage) {
      error = true;
      setPackageNameError("PackageName is required.");
      return;
    }
    {
      // const offer_id = parseInt(moment().format("x").slice(-4));
      const offer_id = null;
      try {
        const res = await AddUtilsData(
          startDate,
          endDate,
          selectedOptionPackage.value,
          full_report,
          offer_id
        );
        if (res && res.data) {
          setUtilsResponse(res.error);
          notification.addNotification({
            title: <span data-notify="icon" className="pe-7s-check"></span>,
            message: (
              <div>
                <b>Utils</b> - Data processing queued. Check later.
              </div>
            ),
            level: "success",
            position: "bl",
            autoDismiss: 15,
          });
          getAllUtilData().then((res) => {
            setUtilData(res.data);
            setloading(false);
            setStartDate("");
            setEndDate("");
            setSelectedOptionPackage(null);
          });
        }
      } catch (error) {
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>Please Enter Package Name</b>
            </div>
          ),
          level: "error",
          position: "bl",
          autoDismiss: 15,
        });
      }
    }
  };

  const refreshTheRowOfUtil = async (id) => {
    const notification = _notificationSystem.current;
    const full_report = "false";

    const getOfferId = utilData.find((data) => id === data.offer_id);
    if (!getOfferId) {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>Error:</b> Offer with ID {id} not found.
          </div>
        ),
        level: "error",
        position: "bl",
        autoDismiss: 10,
      });
      return;
    }

    const today = new Date();
    const options = {
      weekday: "short",
      day: "2-digit",
      month: "short",
      year: "numeric",
    };
    const formattedToday = today
      .toLocaleDateString("en-US", options)
      .replace(/,/g, "");

    const res = await AddUtilsData(
      getOfferId.start_date,
      formattedToday,
      getOfferId.package_id,
      full_report,
      id
    );
    if (res && res.data) {
      setUtilsResponse(res.error);
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-check"></span>,
        message: (
          <div>
            <b>Utils</b> - Data processing queued. Check later.
          </div>
        ),
        level: "success",
        position: "bl",
        autoDismiss: 15,
      });
    }
  };

  const handleDownload = () => {
    const url = URL.createObjectURL(profile);
    const link = document.createElement("a");
    link.href = url;
    link.download = profile.name;
    link.click();
    URL.revokeObjectURL(url);
  };

  const onSubmit = async () => {
    let error = false;
    const notification = _notificationSystem.current;

    if (
      selectStartDate &&
      selectEndDate &&
      new Date(selectEndDate) < new Date(selectStartDate)
    ) {
      error = true;
      setSelectEndDateError("Invalid date range.");
      return;
    }

    if (!selectStartDate) {
      error = true;
      setSelectStartDateError("Start Date is required.");
      return;
    }

    if (!selectEndDate) {
      error = true;
      setSelectEndDateError("End Date is required.");
      return;
    }
    if (!profile) {
      error = true;
      setFileError("Please upload a CSV File");
      return;
    }

    if (!error) {
      const formData = new FormData();
      formData.append("file", profile);
      formData.append("start_date", selectStartDate);
      formData.append("end_date", selectEndDate);

      try {
        const res = await utilImageUpload(formData);
        if (res) {
          setUploadResponse(res.data.message);
          notification.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
              <div>
                <b>{res.data.message}</b>
              </div>
            ),
            level: "success",
            position: "bl",
            autoDismiss: 15,
          });
          getAllCustomUtilData(1).then((res) => {
            setCustomUtilData(res.data);
            setloading(false);
          });
          setProfile("");
          setSelectStartDate("");
          setSelectEndDate("");
        }
      } catch (error) {
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>Invalid CSV, mobile number missing data.</b>
            </div>
          ),
          level: "error",
          position: "bl",
          autoDismiss: 15,
        });
        setProfile("");
        setSelectStartDate("");
        setSelectEndDate("");
      }
    }
  };
  return (
    <div className="main-content">
      <Grid fluid>
        <NotificationSystem ref={_notificationSystem} />
        <br />
        <Card
          content={
            <>
              <form>
                <div className="table-responsive">
                  <Table
                    style={{ border: "none !important", marginTop: "8px" }}
                    className="fl_order_details"
                  >
                    <thead>
                      <tr>
                        <th align="center">
                          <ControlLabel style={{ padding: "5px" }}>
                            Start Date
                          </ControlLabel>
                        </th>
                        <th align="center">
                          <ControlLabel style={{ padding: "5px" }}>
                            End Date
                          </ControlLabel>
                        </th>
                        <th align="center">
                          <ControlLabel
                            style={{ padding: "5px", marginLeft: "12px" }}
                          >
                            Package Name
                          </ControlLabel>
                        </th>
                        <th align="center">
                          <ControlLabel
                            style={{ padding: "5px", marginLeft: "12px" }}
                          ></ControlLabel>
                        </th>
                        <th align="center">
                          <ControlLabel
                            style={{ padding: "5px", marginLeft: "12px" }}
                          >
                            Action
                          </ControlLabel>
                        </th>
                        <th align="center">
                          <Col md={12} sm={12} xs={12}>
                            <FormControl
                              name="searchLeads"
                              value={getBySearch}
                              placeholder="Search campaign name"
                              onChange={(event) => handleSearch(event)}
                              type="text"
                            />
                          </Col>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <Datetime
                            timeFormat={false}
                            dateFormat="YYYY-MM-DD"
                            closeOnSelect={true}
                            value={startDate || ""}
                            onChange={handleDeliveryStartDateChange}
                            inputProps={{ placeholder: "Select Start Date" }}
                          />
                          {startDateError && (
                            <small
                              className="text-danger"
                              style={{ marginLeft: "7px" }}
                            >
                              {startDateError}
                            </small>
                          )}
                        </td>
                        <td>
                          <Datetime
                            timeFormat={false}
                            dateFormat="YYYY-MM-DD"
                            closeOnSelect={true}
                            value={endDate || ""}
                            onChange={handleDeliveryEndDateChange}
                            inputProps={{ placeholder: "Select End Date" }}
                          />
                          {endDateError && (
                            <small
                              className="text-danger"
                              style={{ marginLeft: "7px" }}
                            >
                              {endDateError}
                            </small>
                          )}
                        </td>
                        <td>
                          <Col md={12} lg={12} sm={12} xs={12}>
                            <Select
                              isClearable
                              isSearchable
                              options={optionsPackage}
                              value={selectedOptionPackage}
                              onChange={handleChangePackage}
                              isLoading={loading}
                              placeholder="Select a package"
                              noOptionsMessage={() => "No packages found"}
                              loadingMessage={() => "Loading packages..."}
                            />
                            {packageNameError && (
                              <small
                                className="text-danger"
                                style={{ marginLeft: "4px" }}
                              >
                                {packageNameError}
                              </small>
                            )}
                          </Col>
                        </td>
                        <td></td>
                        <td>
                          <Button
                            style={{ marginLeft: "12px" }}
                            className="btn-color"
                            fill
                            onClick={() => handleOnSubmit()}
                          >
                            Generate
                          </Button>
                          <Button
                            style={{ marginLeft: "12px" }}
                            className="btn-color"
                            fill
                            onClick={() => handleutilReset()}
                          >
                            Clear
                          </Button>
                        </td>
                        <td>
                          <Button
                            style={{ float: "right" }}
                            className="btn-color"
                            fill
                            onClick={() => setIsImgaeUploadModel(true)}
                          >
                            Lead list upload
                            <i class="fa fa-upload" aria-hidden="true"></i>
                          </Button>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <Col>
                    <Card
                      content={
                        <React.Fragment>
                          <Row>
                            <Col md={12}>
                              <Table responsive className="desktop-table">
                                <thead>
                                  <tr>
                                    <th>campaign name</th>
                                    <th>start date</th>
                                    <th>end date</th>
                                    <th>status</th>
                                    <th>Download</th>
                                    <th> Update Refresh</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {loading ? (
                                    <tr>
                                      <td colSpan="10">
                                        <LoadingSpinner />
                                      </td>
                                    </tr>
                                  ) : noRecordFound ||
                                    !utilData ||
                                    utilData.length === 0 ? (
                                    <tr>
                                      <td colSpan="10">
                                        <center>No record found</center>
                                      </td>
                                    </tr>
                                  ) : (
                                    utilData &&
                                    utilData.map((item) => (
                                      <tr>
                                        {" "}
                                        <td>{item.package_name}</td>
                                        <td>{item.start_date}</td>
                                        <td>
                                          {!item.offer_id
                                            ? item.end_date
                                            : item.updated_at}
                                        </td>
                                        <td>{item.status}</td>
                                        <td>
                                          {item.url != null ? (
                                            <Button
                                              simple
                                              bsStyle="success"
                                              bsSize="xs"
                                              onClick={() => {
                                                window.open(item.url, "_blank");
                                                // refreshTheRowOfUtil(
                                                //   item.offer_id
                                                // );
                                              }}
                                            >
                                              <i
                                                className="fa fa-download"
                                                style={{ color: "#9CF196" }}
                                              />
                                            </Button>
                                          ) : (
                                            <Button
                                              bsSize="xs"
                                              simple
                                              disabled
                                              style={{
                                                cursor: "not-allowed",
                                              }}
                                            >
                                              <i
                                                class="fa fa-ban"
                                                aria-hidden="true"
                                                style={{ color: "red" }}
                                              ></i>
                                            </Button>
                                          )}
                                        </td>
                                        <td>
                                          {item.offer_id !== null && (
                                            <Button
                                              onClick={() =>
                                                refreshTheRowOfUtil(
                                                  item.offer_id
                                                )
                                              }
                                            >
                                              <i
                                                className="fa fa-refresh"
                                                style={{ color: "blue" }}
                                                aria-hidden="true"
                                              ></i>
                                            </Button>
                                          )}
                                        </td>
                                      </tr>
                                    ))
                                  )}
                                </tbody>
                              </Table>
                            </Col>
                          </Row>
                          {isPDFLoading && <ScreenLoader />}
                          {isGRNLoading && <ScreenLoader />}
                        </React.Fragment>
                      }
                    />
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Pagination bsSize="medium">{items}</Pagination>
                    </div>
                  </Col>
                </div>
                <br />
                <Modal
                  show={isImgaeUploadModel}
                  onHide={() => setIsImgaeUploadModel(false)}
                  bsSize="lg"
                  backdrop="static"
                >
                  <Modal.Header>
                    <Modal.Title> Upload CSV</Modal.Title>
                  </Modal.Header>
                  <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
                    <Table
                      style={{ border: "none !important", marginTop: "8px" }}
                      className="fl_order_details"
                    >
                      <thead>
                        <tr>
                          <th align="center">
                            <ControlLabel style={{ padding: "5px" }}>
                              Lead file
                            </ControlLabel>
                          </th>
                          <th align="center">
                            <ControlLabel
                              style={{ padding: "5px" }}
                            ></ControlLabel>
                          </th>
                          <th align="center">
                            <ControlLabel style={{ padding: "5px" }}>
                              Start Date
                            </ControlLabel>
                          </th>
                          <th align="center">
                            <ControlLabel style={{ padding: "5px" }}>
                              End Date
                            </ControlLabel>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <input
                              style={{ display: "none" }}
                              id="selectImage"
                              type="file"
                              className="form-control"
                              name="profile"
                              onChange={handleFileChange}
                            />
                            <Button
                              onClick={() => upload()}
                              style={{ color: "#2B3A41" }}
                            >
                              {" "}
                              <i
                                className={
                                  profile == ""
                                    ? "fa fa-plus"
                                    : "fa fa-pencil fa-fw"
                                }
                              ></i>{" "}
                              {profile == "" ? "Choose CSV" : "Change CSV"}
                            </Button>

                            <br />
                            {fileError && (
                              <small
                                className="text-danger"
                                style={{
                                  marginLeft: "4px",
                                  verticalAlign: "sub",
                                }}
                              >
                                {fileError}
                              </small>
                            )}
                          </td>
                          <td>
                            <Button
                              onClick={handleDownload}
                              disabled={!profile}
                              style={{
                                padding: "5px -1px",
                                backgroundColor: profile
                                  ? "#4bb543"
                                  : "#444444",
                                color: "white",
                                border: "none",
                              }}
                            >
                              <i
                                className="fa fa-download"
                                style={{ color: "white" }}
                              />
                            </Button>
                          </td>
                          <td>
                            <Datetime
                              timeFormat={true}
                              dateFormat="YYYY-MM-DD"
                              closeOnSelect={true}
                              value={selectStartDate || ""}
                              onChange={handleSelectStartDateChange}
                              inputProps={{ placeholder: "Select Start Date" }}
                            />
                            {selectStartDateError && (
                              <small
                                className="text-danger"
                                style={{ marginLeft: "8px" }}
                              >
                                {selectStartDateError}
                              </small>
                            )}
                          </td>
                          <td>
                            <Datetime
                              timeFormat={true}
                              dateFormat="YYYY-MM-DD"
                              closeOnSelect={true}
                              value={selectEndDate || ""}
                              onChange={handleSelectEndDateChange}
                              inputProps={{ placeholder: "Select End Date" }}
                            />
                            {selectEndDateError && (
                              <small
                                className="text-danger"
                                style={{ marginLeft: "8px" }}
                              >
                                {selectEndDateError}
                              </small>
                            )}
                          </td>
                          <td>
                            <Button
                              className="btn-fill btn-size btn  "
                              onClick={() => onSubmit()}
                            >
                              Submit
                            </Button>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                    <button
                      class="btn-fill btn   btn btn-default"
                      fill
                      onClick={handleDownloads}
                    >
                      Download sample CSV
                    </button>

                    <Col>
                      <Card
                        content={
                          <React.Fragment>
                            <Row>
                              <Col md={12}>
                                <Table responsive className="desktop-table">
                                  <thead>
                                    <tr>
                                      <th>created_at</th>
                                      <th>start date</th>
                                      <th>end Date</th>
                                      <th>status</th>
                                      <th>Download</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {loading ? (
                                      <tr>
                                        <td colSpan="10">
                                          <LoadingSpinner />
                                        </td>
                                      </tr>
                                    ) : noRecordFound ? (
                                      <tr>
                                        <td colSpan="10">
                                          <center>No record found</center>
                                        </td>
                                      </tr>
                                    ) : (
                                      customUtilData &&
                                      customUtilData.map((item) => (
                                        <tr>
                                          {" "}
                                          <td>{item.created_at}</td>
                                          <td>{item.start_date}</td>
                                          <td>{item.end_date}</td>
                                          <td>{item.status}</td>
                                          <td>
                                            {item.url != null ? (
                                              <Button
                                                simple
                                                bsStyle="success"
                                                bsSize="xs"
                                                onClick={() =>
                                                  window.open(
                                                    item.url,
                                                    "_blank"
                                                  )
                                                }
                                              >
                                                <i
                                                  className="fa fa-download"
                                                  style={{ color: "#9CF196" }}
                                                />
                                              </Button>
                                            ) : (
                                              <Button
                                                bsSize="xs"
                                                simple
                                                disabled
                                                style={{
                                                  cursor: "not-allowed",
                                                }}
                                              >
                                                <i
                                                  class="fa fa-ban"
                                                  aria-hidden="true"
                                                  style={{ color: "red" }}
                                                ></i>
                                              </Button>
                                            )}
                                          </td>
                                        </tr>
                                      ))
                                    )}
                                  </tbody>
                                </Table>
                              </Col>
                            </Row>
                            {isPDFLoading && <ScreenLoader />}
                            {isGRNLoading && <ScreenLoader />}
                          </React.Fragment>
                        }
                      />
                    </Col>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      className="btn-fill btn btn-danger"
                      onClick={() => {
                        setIsImgaeUploadModel(false);
                        setProfile("");
                        setSelectStartDate("");
                        setSelectEndDate("");
                        setSelectStartDateError(null);
                        setSelectEndDateError(null);
                        setFileError(null);
                      }}
                    >
                      Cancel
                    </Button>
                  </Modal.Footer>
                </Modal>
              </form>
            </>
          }
        />
      </Grid>
    </div>
  );
};

export default ProductUtility;
